<div class="container" *ngIf="(loaded$ | async) === true">
  <div *ngIf="(isError$ | async) !== true">
    <div class="question-image-container" *ngIf="(paramType$ | async) === 'q'">
      <ng-container *ngFor="let image of questionImages$ | async">
        <img
          [src]="image"
          class="image-container"
          [ngClass]="subjectId === '03' ? 'national-language-style' : 'default-style'"
          draggable="false"
        />
      </ng-container>
    </div>

    <div class="answer-image-container" *ngIf="(paramType$ | async) === 'a'">
      <ng-container *ngFor="let image of answerImages$ | async">
        <img
          [src]="image"
          class="image-container"
          [ngClass]="subjectId === '03' ? 'national-language-style' : 'default-style'"
          draggable="false"
        />
      </ng-container>
    </div>

    <div class="f-image-container" *ngIf="(paramType$ | async) === 'f'">
      <ng-container *ngFor="let image of fImages$ | async">
        <img [src]="image" class="image-container f-style" draggable="false" (load)="onFImageLoaded($event)" />
      </ng-container>
    </div>
  </div>
</div>
